import { RouteObject, Navigate } from 'react-router-dom';
import { InvoicingRoutes } from './modules/invoicing';
import { BillingRoutes } from './modules/billing';
import { GlRoutes } from './modules/gl';
import { AccountingRoutes } from './modules/accounting';
import { TaxRoutes } from './modules/tax';
import { ExpensesRoutes } from './modules/expenses';
import { BankRoutes } from './modules/bank';
import { ApRoutes } from './modules/ap';
import { PayrollLinkRoutes } from './modules/payroll-link';
import { AnalyticsRoutes } from './modules/analytics';
import { ComplianceRoutes } from './modules/compliance';

export const financeRoutes: RouteObject[] = [
  { path: '', element: <Navigate to="invoicing/invoices" replace /> },
  InvoicingRoutes,
  BillingRoutes,
  GlRoutes,
  AccountingRoutes,
  TaxRoutes,
  ExpensesRoutes,
  BankRoutes,
  ApRoutes,
  PayrollLinkRoutes,
  AnalyticsRoutes,
  ComplianceRoutes,
  { path: 'invoices', element: <Navigate to="invoicing/invoices" replace />, handle: { crumb: 'Invoices' } },
  { path: 'payments', element: <Navigate to="invoicing/payments" replace />, handle: { crumb: 'Payments' } },
  { path: 'ledger', element: <Navigate to="gl/chart-of-accounts" replace />, handle: { crumb: 'General Ledger' } },
];

export default financeRoutes;
